import {editor} from "monaco-editor";
import {validateXML, XMLFormatter} from "@/lib/xml";
import {ValidateYAML} from "@/lib/yaml";
import {JSONFormatter, validateJSON} from "@/lib/json";
import {ConversionDataTypes} from "@/state/features/types";

type EditorType = typeof editor;

export interface CustomMarkers{
    line: number;
    column: number;
    message: string;
}

export const SetCustomEditorMarkers = (monaco: EditorType ,currentEditor: editor.IStandaloneCodeEditor,  markers : Array<CustomMarkers>, langauge: string) =>{

    const localMarkers = markers.map((marker) => {
        return {startLineNumber: marker.line,
            endLineNumber: marker.line,
            startColumn: marker.column,
            endColumn: marker.column,
            message:marker.message,
            severity: 8
        };
    })
    const model = currentEditor.getModel();
    if(!!model){
        monaco.setModelMarkers(model,langauge , localMarkers)
    }
}

export const HandleXMLChanges = (xmlValue: string, monaco: EditorType, localEditor: editor.IStandaloneCodeEditor) => {
    const errors = validateXML(xmlValue);
    if(!!errors) {
        SetCustomEditorMarkers(monaco, localEditor, errors, "xml");
    }
    else{
        SetCustomEditorMarkers(monaco, localEditor, [], "xml");
    }
}

export const HandleYAMLChanges = (yamlValue: string, monaco: EditorType, localEditor: editor.IStandaloneCodeEditor) => {
    const errors = ValidateYAML(yamlValue);
    if(!!errors) {
        SetCustomEditorMarkers(monaco, localEditor, errors, "yaml");
    }
    else{
        SetCustomEditorMarkers(monaco, localEditor, [], "yaml");
    }
}

export const HandleJSONChanges = (jsonString: string, monaco: EditorType, localEditor: editor.IStandaloneCodeEditor) => {
    const errors = validateJSON(jsonString);
    if(!!errors) {
        SetCustomEditorMarkers(monaco, localEditor, errors, "json");
    }
    else {
        SetCustomEditorMarkers(monaco, localEditor, [], "json");
    }
}

export const CodeFormatter = (text: string, language: ConversionDataTypes) => {
    switch (language) {
        case ConversionDataTypes.JSON: return JSONFormatter(text);
        case ConversionDataTypes.XML: return XMLFormatter(text);
        default: return text;
    }
}
